import { createStyles } from '@material-ui/core';

export default () => createStyles({
  logoWrapper: {
    textAlign: 'center',
    margin: '31px 0',
    lineHeight: 0,
    height: '95px',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
  card: {
    borderRadius: 10,
    height: '100%',
  },
  apiName: {
    color: '#DB5C0E',
    fontWeight: 'bold',
    fontSize: 22,
    lineHeight: '28px',
  },
  apiDescription: {
    fontSize: '16px',
    lineHeight: '20px',
    color: '#979797',
    '& .deviceId': {
      fontWeight: 'bold',
      color: '#000',
    },
  },
  switchWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'flex-end',
  },
});
